function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* global document, window */


var VKApi =
/*#__PURE__*/
function () {
  function VKApi(apiId, options) {
    if (options === void 0) {
      options = {};
    }

    this.apiId = apiId;
    this.options = _objectSpread({
      version: 159,
      onlyWidgets: true
    }, options);

    if (!apiId) {
      throw new Error("You need to set apiId");
    }

    this.promise = null;
    this.init();
  }

  var _proto = VKApi.prototype;

  _proto.init = function init() {
    var apiId = this.apiId,
        _this$options = this.options,
        version = _this$options.version,
        onlyWidgets = _this$options.onlyWidgets;
    if (this.promise) return this.promise;
    this.promise = new Promise(function (resolve) {
      var baseUrl = "https://vk.com/js/api/openapi.js?" + version;

      window.vkAsyncInit = function () {
        window.VK.init({
          apiId: apiId,
          onlyWidgets: onlyWidgets
        });
        resolve(window.VK);
      };

      if (document.getElementById("vk-openapi")) {
        return;
      }

      var script = document.createElement("script");
      script.type = "text/javascript";
      script.id = "vk-openapi";
      script.src = baseUrl;
      script.async = true;
      document.head.appendChild(script);
    });
    return this.promise;
  };

  return VKApi;
}();

export { VKApi as default };